import { render, staticRenderFns } from "./FCCCompetitionShirts.vue?vue&type=template&id=6025d4e4"
import script from "./FCCCompetitionShirts.vue?vue&type=script&lang=js"
export * from "./FCCCompetitionShirts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports